// Create final store using all reducers and applying middleware

// Redux utility functions
import { compose, createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { rootReducer } from './root-reducer';
import rootSaga from './root-saga';

const sagaMiddleware = createSagaMiddleware();

// eslint-disable-next-line no-underscore-dangle
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = composeEnhancers(applyMiddleware(sagaMiddleware))(createStore)(rootReducer);

sagaMiddleware.run(rootSaga);

export default store;

const dispatch = store.dispatch;

export { dispatch };
